import React from "react";
import { Page, StyleSheet } from "@react-pdf/renderer";
import Footer from "./Footer";
import Header from "./Header";
import Title from "./common/Title";
import FlowData from "./FlowData";
import { config } from "./common/config";

const styles = StyleSheet.create({
  page: {
    padding: 50,
    paddingTop: 70,
    fontFamily: config.fontFamily,
    fontSize: config.normalFontSize,
  },
});

const FlowRelatory = ({ relatory }) => (
  <Page size="A4" style={styles.page} wrap>
    <Header relatory={relatory} />
    <Title>Informações do Fluxo</Title>
    <FlowData relatory={relatory} />
    <Footer />
  </Page>
);

export default FlowRelatory;
